//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  af: "Afghanistan",
  eg: "Ägypten",
  ax: "Ålandinseln",
  al: "Albanien",
  dz: "Algerien",
  as: "Amerikanisch-Samoa",
  vi: "Amerikanische Jungferninseln",
  um: "Amerikanische Überseeinseln",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguilla",
  aq: "Antarktis",
  ag: "Antigua und Barbuda",
  gq: "Äquatorialguinea",
  ar: "Argentinien",
  am: "Armenien",
  aw: "Aruba",
  az: "Aserbaidschan",
  et: "Äthiopien",
  au: "Australien",
  bs: "Bahamas",
  bh: "Bahrain",
  bd: "Bangladesch",
  bb: "Barbados",
  by: "Belarus",
  be: "Belgien",
  bz: "Belize",
  bj: "Benin",
  bm: "Bermuda",
  bt: "Bhutan",
  bo: "Bolivien",
  bq: "Bonaire, Sint Eustatius und Saba",
  ba: "Bosnien und Herzegowina",
  bw: "Botsuana",
  bv: "Bouvetinsel",
  br: "Brasilien",
  vg: "Britische Jungferninseln",
  io: "Britisches Territorium im Indischen Ozean",
  bn: "Brunei Darussalam",
  bg: "Bulgarien",
  bf: "Burkina Faso",
  bi: "Burundi",
  cv: "Cabo Verde",
  cl: "Chile",
  cn: "China",
  ck: "Cookinseln",
  cr: "Costa Rica",
  ci: "Côte d’Ivoire",
  cw: "Curaçao",
  dk: "Dänemark",
  de: "Deutschland",
  dm: "Dominica",
  do: "Dominikanische Republik",
  dj: "Dschibuti",
  ec: "Ecuador",
  sv: "El Salvador",
  er: "Eritrea",
  ee: "Estland",
  sz: "Eswatini",
  fk: "Falklandinseln",
  fo: "Färöer",
  fj: "Fidschi",
  fi: "Finnland",
  fr: "Frankreich",
  gf: "Französisch-Guayana",
  pf: "Französisch-Polynesien",
  tf: "Französische Süd- und Antarktisgebiete",
  ga: "Gabun",
  gm: "Gambia",
  ge: "Georgien",
  gh: "Ghana",
  gi: "Gibraltar",
  gd: "Grenada",
  gr: "Griechenland",
  gl: "Grönland",
  gp: "Guadeloupe",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernsey",
  gn: "Guinea",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  ht: "Haiti",
  hm: "Heard und McDonaldinseln",
  hn: "Honduras",
  in: "Indien",
  id: "Indonesien",
  iq: "Irak",
  ir: "Iran",
  ie: "Irland",
  is: "Island",
  im: "Isle of Man",
  il: "Israel",
  it: "Italien",
  jm: "Jamaika",
  jp: "Japan",
  ye: "Jemen",
  je: "Jersey",
  jo: "Jordanien",
  ky: "Kaimaninseln",
  kh: "Kambodscha",
  cm: "Kamerun",
  ca: "Kanada",
  kz: "Kasachstan",
  qa: "Katar",
  ke: "Kenia",
  kg: "Kirgisistan",
  ki: "Kiribati",
  cc: "Kokosinseln",
  co: "Kolumbien",
  km: "Komoren",
  cg: "Kongo-Brazzaville",
  cd: "Kongo-Kinshasa",
  hr: "Kroatien",
  cu: "Kuba",
  kw: "Kuwait",
  la: "Laos",
  ls: "Lesotho",
  lv: "Lettland",
  lb: "Libanon",
  lr: "Liberia",
  ly: "Libyen",
  li: "Liechtenstein",
  lt: "Litauen",
  lu: "Luxemburg",
  mg: "Madagaskar",
  mw: "Malawi",
  my: "Malaysia",
  mv: "Malediven",
  ml: "Mali",
  mt: "Malta",
  ma: "Marokko",
  mh: "Marshallinseln",
  mq: "Martinique",
  mr: "Mauretanien",
  mu: "Mauritius",
  yt: "Mayotte",
  mx: "Mexiko",
  fm: "Mikronesien",
  mc: "Monaco",
  mn: "Mongolei",
  me: "Montenegro",
  ms: "Montserrat",
  mz: "Mosambik",
  mm: "Myanmar",
  na: "Namibia",
  nr: "Nauru",
  np: "Nepal",
  nc: "Neukaledonien",
  nz: "Neuseeland",
  ni: "Nicaragua",
  nl: "Niederlande",
  ne: "Niger",
  ng: "Nigeria",
  nu: "Niue",
  kp: "Nordkorea",
  mp: "Nördliche Marianen",
  mk: "Nordmazedonien",
  nf: "Norfolkinsel",
  no: "Norwegen",
  om: "Oman",
  at: "Österreich",
  pk: "Pakistan",
  ps: "Palästinensische Autonomiegebiete",
  pw: "Palau",
  pa: "Panama",
  pg: "Papua-Neuguinea",
  py: "Paraguay",
  pe: "Peru",
  ph: "Philippinen",
  pn: "Pitcairninseln",
  pl: "Polen",
  pt: "Portugal",
  pr: "Puerto Rico",
  md: "Republik Moldau",
  re: "Réunion",
  rw: "Ruanda",
  ro: "Rumänien",
  ru: "Russland",
  sb: "Salomonen",
  zm: "Sambia",
  ws: "Samoa",
  sm: "San Marino",
  st: "São Tomé und Príncipe",
  sa: "Saudi-Arabien",
  se: "Schweden",
  ch: "Schweiz",
  sn: "Senegal",
  rs: "Serbien",
  sc: "Seychellen",
  sl: "Sierra Leone",
  zw: "Simbabwe",
  sg: "Singapur",
  sx: "Sint Maarten",
  sk: "Slowakei",
  si: "Slowenien",
  so: "Somalia",
  hk: "Sonderverwaltungsregion Hongkong",
  mo: "Sonderverwaltungsregion Macau",
  es: "Spanien",
  sj: "Spitzbergen und Jan Mayen",
  lk: "Sri Lanka",
  bl: "St. Barthélemy",
  sh: "St. Helena",
  kn: "St. Kitts und Nevis",
  lc: "St. Lucia",
  mf: "St. Martin",
  pm: "St. Pierre und Miquelon",
  vc: "St. Vincent und die Grenadinen",
  za: "Südafrika",
  sd: "Sudan",
  gs: "Südgeorgien und die Südlichen Sandwichinseln",
  kr: "Südkorea",
  ss: "Südsudan",
  sr: "Suriname",
  sy: "Syrien",
  tj: "Tadschikistan",
  tw: "Taiwan",
  tz: "Tansania",
  th: "Thailand",
  tl: "Timor-Leste",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad und Tobago",
  td: "Tschad",
  cz: "Tschechien",
  tn: "Tunesien",
  tr: "Türkei",
  tm: "Turkmenistan",
  tc: "Turks- und Caicosinseln",
  tv: "Tuvalu",
  ug: "Uganda",
  ua: "Ukraine",
  hu: "Ungarn",
  uy: "Uruguay",
  uz: "Usbekistan",
  vu: "Vanuatu",
  va: "Vatikanstadt",
  ve: "Venezuela",
  ae: "Vereinigte Arabische Emirate",
  us: "Vereinigte Staaten",
  gb: "Vereinigtes Königreich",
  vn: "Vietnam",
  wf: "Wallis und Futuna",
  cx: "Weihnachtsinsel",
  eh: "Westsahara",
  cf: "Zentralafrikanische Republik",
  cy: "Zypern",
};
